import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../atoms/Button/Button';
import { useTranslation } from '../../i18n/useTranslation';

export interface LogTestsButtonProps {
  aquariumId: string;
  /** Element id; the test session returns focus to it (see useReturnFocus). */
  id: string;
  variant?: 'primary' | 'secondary';
}

/**
 * Opens the multi-parameter test session (#1740) for an aquarium. The session
 * navigates back to the current page and focuses this button after Save or
 * Cancel; the page restores focus with useReturnFocus().
 */
export function LogTestsButton({ aquariumId, id, variant = 'secondary' }: LogTestsButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Button
      id={id}
      type="button"
      variant={variant}
      onClick={() =>
        navigate(`/aquariums/${aquariumId}/measurements/session`, {
          state: { returnTo: `${location.pathname}${location.search}`, invokerElementId: id },
        })
      }
    >
      {t('measurement.logTests')}
    </Button>
  );
}
